import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { IconDown, IconHeart } from "@arco-design/web-react/icon";
import { Message, Tooltip } from "@arco-design/web-react";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import {
  deletesScriptReader,
  getHotspotVideo,
  getNewHotSpot,
  getReaderCreator,
  getReaderCreatorVideos,
  getScriptReader,
  getUpInfo,
} from "@/services/creativeScript/explosiveScript";

function useData() {
  const navigat = useNavigate();
  const [tagList, setTagList] = useState([]);
  const [tagLoading, setTagLoading] = useState<boolean>(false);
  function restructureArray(arr) {
    // 先创建一个空的对象，用来存储所有的id和对应的数据
    const map = {};

    // 遍历数组，将每个元素的id和元素本身存储到map中
    arr.forEach((item) => {
      map[item.id] = { ...item, children: [] };
    });

    // 再次遍历数组，将子级元素放入父级的children数组中
    arr.forEach((item) => {
      if (item.parent_id) {
        map[item.parent_id].children.push(map[item.id]);
      }
    });

    // 过滤出没有parent_id的项（即根节点）
    return arr.filter((item) => !item.parent_id).map((item) => map[item.id]);
  }
  const handleGetNewHotSpot = async (type) => {
    setTagLoading(true);
    const res = await getNewHotSpot({ type });
    setTagLoading(false);

    if (res?.code == 0) {
      setTagList([
        {
          title: "行业",
          checkAll: false,
          children: [
            {
              label: "全部",
              value: "全部",
              checked: true,
            },
          ].concat(restructureArray(res.data.items)),
        },
        {
          title: "类型",
          checkAll: false,
          children: [
            {
              label: "视频总榜",
              value: 1001,
              checked: true,
              id: 1,
            },
            {
              label: "低粉爆款",
              value: 1002,
              checked: false,
              id: 2,
            },
            {
              label: "高完播率",
              value: 1003,
              checked: false,
              id: 3,
            },
            {
              label: "高涨粉率",
              value: 1004,
              checked: false,
              id: 4,
            },
            {
              label: "高点赞率",
              value: 1005,
              checked: false,
              id: 5,
            },
          ],
        },
        {
          title: "时间",
          checkAll: false,
          children: [
            {
              label: "近一小时",
              value: 1,
              checked: true,
              id: 1,
            },
            {
              label: "近一天",
              value: 24,
              checked: false,
              id: 2,
            },
            {
              label: "近三天",
              value: 72,
              checked: false,
              id: 3,
            },
            {
              label: "近七天",
              value: 168,
              checked: false,
              id: 4,
            },
          ],
        },
      ]);
    }
  };
  useEffect(() => {
    handleGetNewHotSpot(1);
  }, []);

  const [creatorsList, setCreatorsList] = useState([]);
  const [creatorsListEctype, setCreatorsListEctype] = useState([]);
  const [creatorsLoading, setCreatorsLoading] = useState<boolean>(false);
  const [isCreators, setIsCreators] = useState<boolean>(true);
  const [netCursor, setNetCursor] = useState<number>(0);
  const [creatorVideoSearch, setCreatorVideoSearch] = useState({
    keyword: "",
    platform: 1,
    influencer_id: [],
    sort_field: undefined,
    sort_sc: undefined,
    cursor: 0,
    limit: 30,
  });
  const [creatorVideoSort, setCreatorVideoSort] = useState({
    sort_field: "",
    sort_sc: "",
  });
  const sortArray = (arr, key, order) => {
    // 如果排序方式为空字符串，则返回原数组
    if (order === "") {
      return creatorsListEctype.length ? creatorsListEctype : arr;
    }
    const newArr = [...arr];
    // 验证排序字段是否合法
    const validKeys = [
      "collect_count",
      "like_count",
      "comment_count",
      "share_count",
    ];
    if (!validKeys.includes(key)) {
      throw new Error("排序字段无效");
    }
    setIsCreators(true);
    // 根据排序方式进行升序或降序排序
    return newArr.sort((a, b) => {
      if (order === "desc") {
        return a[key] - b[key];
      } else if (order === "asc") {
        return b[key] - a[key];
      } else {
        throw new Error("排序方式无效");
      }
    });
  };
  const handleReaderCreatorVideos = async () => {
    setCreatorsLoading(true);
    setIsCreators(true);

    const res = await getReaderCreatorVideos(creatorVideoSearch);
    setCreatorsLoading(false);
    if (res?.code == 0 && res.data.items) {
      setNetCursor(res.data.next_cursor);
      const newArr = [...creatorsList];
      setCreatorsList(
        newArr.concat(
          res.data.items.map((v) => ({
            ...v,
            item_cover_url: v.video_avatar_url,
            like_cnt: v.like_count,
            nick_name: v.nickname,
            share_cnt: v.share_count,
            item_title: v.title,
            type: "my",
          })),
        ),
      );
      // setCreatorsListEctype(
      //   newArr.concat(
      //     res.data.items.map((v) => ({
      //       ...v,
      //       item_cover_url: v.video_avatar_url,
      //       like_cnt: v.like_count,
      //       nick_name: v.nickname,
      //       share_cnt: v.share_count,
      //       item_title: v.title,
      //       type: "my",
      //     })),
      //   ),
      // );
    } else {
      setIsCreators(false);
    }
  };

  useEffect(() => {
    handleReaderCreatorVideos();
  }, [creatorVideoSearch]);

  const [hotspotVideoList, setHotspotVideoList] = useState<any>([]);
  const [isVideos, setIsVideos] = useState<boolean>(true);
  const [hotspotVideoLoading, setHotspotVideoLoading] =
    useState<boolean>(false);
  const [hotspotVideoSearch, setHotspotVideoSearch] = useState({
    page: 1,
    page_size: 30,
    date_window: 24,
    sub_type: 1001,
    tags: [],
  });
  const handleHotspotVideo = async () => {
    setHotspotVideoLoading(true);
    setIsVideos(true);
    const res = await getHotspotVideo(hotspotVideoSearch);
    setHotspotVideoLoading(false);
    if (res?.code == 0 && res.data.items) {
      const newArr = [...hotspotVideoList];
      setHotspotVideoList(
        newArr.concat(res.data.items.filter((v) => v.item_id)),
      );
    } else {
      setIsVideos(false);
    }
  };
  const handleVideoListSort = (key, value) => {
    // creatorVideoSort.sort_field = key;
    // creatorVideoSort.sort_sc = value ? value : "";
    // setCreatorVideoSort({ ...creatorVideoSort });
    creatorVideoSearch.sort_field = key;
    creatorVideoSearch.sort_sc = value ? value : "";
    creatorVideoSearch.cursor = 0;
    setCreatorsList([]);
    setCreatorVideoSearch({ ...creatorVideoSearch });
  };
  useEffect(() => {
    handleHotspotVideo();
  }, [hotspotVideoSearch]);

  // useEffect(() => {
  //   setCreatorsList(
  //     sortArray(
  //       creatorsList,
  //       creatorVideoSort.sort_field,
  //       creatorVideoSort.sort_sc,
  //     ),
  //   );
  // }, [creatorVideoSort]);
  const [getUpLoading, setGetUpLoading] = useState<boolean>(false);
  const [getUpId, setGetUpId] = useState("");
  const handleScriptReader = async (data) => {
    const res = await getScriptReader(data);
    setGetUpLoading(false);
    if (res?.code !== 0 || !res.data.id) {
      Message.error(res);
      setGetUpId("");
    } else {
      Message.success("订阅成功, 新订阅账号的视频收集大约需要 1 天");
    }
  };
  const handleGetUpInfo = async (sec_user_id, item_id = "") => {
    setGetUpId(item_id);
    setGetUpLoading(true);
    const res = await getUpInfo(sec_user_id);
    if (res?.code == 0 && res.data.item) {
      const { avatar_url, nickname, sec_uid, unique_id } = res.data.item;
      handleScriptReader({
        nick_name: nickname,
        third_uuid: unique_id,
        sec_uid,
        avatar_url,
        platform: 1,
      });
    } else {
      setGetUpLoading(false);
      setGetUpId("");
      Message.error(JSON.stringify(res));
    }
  };
  const [accountList, setAccountList] = useState([]);
  const [accountLoading, setAccountLoading] = useState<boolean>(false);
  const handleReaderCreator = async () => {
    setAccountLoading(true);
    const res = await getReaderCreator();
    setAccountLoading(false);

    if (res?.code == 0 && res.data.items) {
      setAccountList(res.data.items);
    }
  };
  const [clickedIndexes, setClickedIndexes] = useState([]);

  const handleClick = (index) => {
    setCreatorsList([]);
    setCreatorsListEctype([]);
    setIsCreators(true);
    setNetCursor(0);

    if (!index) {
      creatorVideoSearch.influencer_id = [];
      creatorVideoSearch.cursor = 0;
      setCreatorVideoSearch((prevState) => ({
        ...prevState,
        influencer_id: [],
      }));
      setClickedIndexes([]);
      return;
    }

    setClickedIndexes((prevIndexes) => {
      const newIndexes = prevIndexes.includes(index)
        ? prevIndexes.filter((i) => i !== index) // 移除已存在的 index
        : [...prevIndexes, index]; // 添加新的 index
      creatorVideoSearch.influencer_id = newIndexes;
      creatorVideoSearch.cursor = 0;
      setCreatorVideoSearch((prevState) => ({
        ...prevState,
        influencer_id: newIndexes,
      }));
      return newIndexes;
    });
  };

  const handleDeletesScriptReader = async (id) => {
    const res = await deletesScriptReader(id);
    if (res?.code == 0) {
      Message.success("取消订阅成功");
      handleReaderCreator();
    }
  };

  const isContinuousScrollingRef = useRef(false);
  const [currentDirection, setCurrentDirection] = useState(0); // 当前滚动方向
  const [isAtLeft, setIsAtLeft] = useState(true); // 是否已经滚动到最左边
  const [isAtRight, setIsAtRight] = useState(false); // 是否已经滚动到最右边
  const contentWrapperRef = useRef(null);
  const scrollAmount = 160; // 每次滚动的距离
  const continuousScrollSpeed = 10; // 连续滚动时的速度
  const scrollTimeoutRef = useRef(null); // 用于存储定时器
  const [startTimer, setStartTimer] = useState(null);
  const [timeDifference, setTimeDifference] = useState(0);
  const [isDragging, setIsDragging] = useState(false); // 是否正在拖拽
  const [startX, setStartX] = useState(0); // 鼠标按下时的起始位置
  const [scrollStart, setScrollStart] = useState(0); // 滚动容器的起始位置

  // 更新按钮的显隐
  const updateButtonVisibility = () => {
    const contentWrapper = contentWrapperRef.current;
    const atLeft = contentWrapper.scrollLeft === 0;
    const atRight =
      contentWrapper.scrollLeft ===
      contentWrapper.scrollWidth - contentWrapper.clientWidth;

    setIsAtLeft(atLeft);
    setIsAtRight(atRight);
  };

  // 离散滚动（短按）
  const discreteScroll = (direction) => {
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // 连续滚动（长按）
  const continuousScroll = (direction) => {
    if (isContinuousScrollingRef.current && contentWrapperRef.current) {
      contentWrapperRef.current.scrollLeft += direction * continuousScrollSpeed;
      requestAnimationFrame(() => continuousScroll(direction));
    }
  };

  const handleMouseDown = (direction) => {
    setCurrentDirection(direction);

    // 设置定时器，200ms 后认为是长按
    scrollTimeoutRef.current = setTimeout(() => {
      // setIsContinuousScrolling(true);
      isContinuousScrollingRef.current = true;
      continuousScroll(direction);
    }, 200);
  };

  const handleMouseUpOrLeave = () => {
    // 清理定时器
    const nowTimer = new Date().getTime();
    if (timeDifference !== 301.1) {
      setTimeDifference(nowTimer - startTimer);
    }

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
      // 如果长按未触发，则执行一次离散滚动
      if (!isContinuousScrollingRef.current) {
        discreteScroll(currentDirection);
      }
    }
    isContinuousScrollingRef.current = false;
    setIsDragging(false); // 释放拖拽状态

    // 恢复可选内容
    if (contentWrapperRef.current) {
      contentWrapperRef.current.style.userSelect = "auto";
      contentWrapperRef.current.style.cursor = "grab";
    }
  };

  // 鼠标拖动事件
  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const deltaX = e.clientX - startX; // 计算鼠标水平移动距离
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollLeft = scrollStart - deltaX; // 更新滚动位置
      setTimeDifference(301.1);
    }
  };

  const handleMouseDownDrag = (e) => {
    setStartTimer(new Date().getTime());
    setTimeDifference(0);
    setIsDragging(true);
    setStartX(e.clientX); // 记录鼠标按下时的位置
    setScrollStart(contentWrapperRef.current.scrollLeft); // 记录当前滚动位置

    // 禁止文本选择
    if (contentWrapperRef.current) {
      contentWrapperRef.current.style.userSelect = "none";
      contentWrapperRef.current.style.cursor = "grabbing";
    }
  };
  // 监听滚动事件
  useEffect(() => {
    const contentWrapper = contentWrapperRef.current;
    if (!contentWrapper) return;
    const handleScroll = () => {
      updateButtonVisibility();
    };

    contentWrapper.addEventListener("scroll", handleScroll);

    // 初始化时检查按钮显示状态
    updateButtonVisibility();

    // 清理监听器
    return () => {
      contentWrapper.removeEventListener("scroll", handleScroll);
    };
  }, [accountList]);

  const subscriptionTagList = [];
  return {
    tagList,
    tagLoading,
    creatorsList,
    creatorsLoading,
    creatorVideoSearch,
    setCreatorVideoSearch,
    setHotspotVideoList,
    hotspotVideoList,
    hotspotVideoLoading,
    hotspotVideoSearch,
    setHotspotVideoSearch,
    handleScriptReader,
    handleGetUpInfo,
    getUpLoading,
    getUpId,
    handleVideoListSort,
    handleReaderCreator,
    accountList,
    handleClick,
    clickedIndexes,
    accountLoading,
    netCursor,
    setNetCursor,
    setCreatorsList,
    setCreatorsListEctype,
    handleDeletesScriptReader,
    isCreators,
    isVideos,
    isAtLeft,
    handleMouseDown,
    handleMouseUpOrLeave,
    isAtRight,
    contentWrapperRef,
    handleMouseMove,
    handleMouseDownDrag,
    isDragging,
    timeDifference,
  };
}

export default useData;
